webpackJsonp([44341822457911],{

/***/ 412:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactPlayer = __webpack_require__(32);
	
	var _reactPlayer2 = _interopRequireDefault(_reactPlayer);
	
	__webpack_require__(790);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var VideoPopup = function (_Component) {
	  _inherits(VideoPopup, _Component);
	
	  function VideoPopup() {
	    _classCallCheck(this, VideoPopup);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  VideoPopup.prototype.render = function render() {
	    if (this.props.show) {
	      return _react2.default.createElement(
	        "div",
	        { className: "videopopup" },
	        _react2.default.createElement(
	          "button",
	          { className: "videopopup__close", onClick: this.props.onClose },
	          "\u2715"
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "videopopup__text" },
	          this.props.text
	        ),
	        _react2.default.createElement("hr", { className: "videopopup__hr" }),
	        _react2.default.createElement(
	          "div",
	          { className: "videopopup__player-wrapper" },
	          _react2.default.createElement(_reactPlayer2.default, {
	            config: {
	              youtube: {
	                playerVars: { showinfo: 1, controls: 1, autoplay: 0 }
	              }
	            }
	            // playing={this.props.show}
	            , className: "videopop__video",
	            width: "100%",
	            height: "100%",
	            url: this.props.url
	          })
	        )
	      );
	    } else {
	      return null;
	    }
	  };
	
	  return VideoPopup;
	}(_react.Component);
	
	VideoPopup.defaultProps = {
	  show: false,
	  url: "",
	  onClose: function onClose() {},
	  text: ""
	};
	
	exports.default = VideoPopup;
	module.exports = exports["default"];

/***/ }),

/***/ 790:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 585:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.press = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(77);
	
	var _Heading = __webpack_require__(7);
	
	var _Heading2 = _interopRequireDefault(_Heading);
	
	var _blogConstant = __webpack_require__(65);
	
	var _contentPage = __webpack_require__(4);
	
	var _contentPage2 = _interopRequireDefault(_contentPage);
	
	var _meta = __webpack_require__(5);
	
	var _meta2 = _interopRequireDefault(_meta);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _gatsbyLink = __webpack_require__(6);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _videopopup = __webpack_require__(412);
	
	var _videopopup2 = _interopRequireDefault(_videopopup);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var press = exports.press = function (_React$Component) {
	  _inherits(press, _React$Component);
	
	  function press(args) {
	    _classCallCheck(this, press);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, args));
	
	    _this.toggleVideo = function () {
	      _this.setState({ showVideo: !_this.state.showVideo });
	    };
	
	    _this.playCurrentVideo = function (video, text) {
	      _this.setState({ currentVideoLink: video, currentText: text }, function () {
	        _this.toggleVideo();
	      });
	    };
	
	    _this.state = {
	      currentVideoLink: "",
	      showVideo: false,
	      currentText: ""
	    };
	    return _this;
	  }
	
	  press.prototype.render = function render() {
	    var _this2 = this;
	
	    var location = this.props.location;
	
	
	    var pressJSX = _blogConstant.pressContent.map(function (item, i) {
	      if (item.type === "link") {
	        return _react2.default.createElement(
	          "div",
	          { className: " col-lg-4 col-md-4 col-sm-6 col-xs-12" },
	          _react2.default.createElement(
	            "div",
	            { className: "Bcard", key: i },
	            _react2.default.createElement(
	              "a",
	              { href: item.link, target: "_blank" },
	              _react2.default.createElement(
	                "div",
	                { className: "blog_card" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "card_img" },
	                  _react2.default.createElement("img", { src: item.bimg, alt: item.title })
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "bcard_content" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "Press_heading_top" },
	                    item.pname
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "card_heading1" },
	                    item.title
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "card_date" },
	                    item.date
	                  )
	                )
	              )
	            )
	          )
	        );
	      } else if (item.type === "video") {
	        return _react2.default.createElement(
	          "div",
	          { className: " col-lg-4 col-md-4 col-sm-6 col-xs-12" },
	          _react2.default.createElement(
	            "div",
	            {
	              className: "Bcard",
	              onClick: function onClick() {
	                return _this2.playCurrentVideo(item.link, item.title);
	              },
	              key: i,
	              style: { cursor: "pointer" }
	            },
	            _react2.default.createElement(
	              "div",
	              { className: "blog_card" },
	              _react2.default.createElement(
	                "div",
	                { className: "card_img" },
	                _react2.default.createElement("img", { src: item.bimg, alt: item.title })
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "bcard_content" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "Press_heading_top" },
	                  item.pname
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "card_heading1" },
	                  item.title
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "card_date" },
	                  item.date
	                )
	              )
	            )
	          )
	        );
	      }
	    });
	
	    return _react2.default.createElement(
	      _contentPage2.default,
	      null,
	      _react2.default.createElement(_videopopup2.default, {
	        url: this.state.currentVideoLink,
	        show: this.state.showVideo,
	        onClose: this.toggleVideo,
	        text: this.state.currentText
	      }),
	      _react2.default.createElement(_meta2.default, {
	        title: "Winpe | In the Press",
	        image: "https://winpeforum.com/assets/elements/WinPE_Home_Page_link_image1.jpg",
	        description: "View news features on Winpe in leading business publications. For media inquiries, please write to info@winpeforum.com",
	        location: location
	      }),
	      _react2.default.createElement(
	        "div",
	        { className: "section__content" },
	        _react2.default.createElement(
	          "div",
	          { className: "pview_wrapper" },
	          _react2.default.createElement(
	            "div",
	            { className: "back_event" },
	            _react2.default.createElement(
	              _gatsbyLink2.default,
	              { to: "/home" },
	              _react2.default.createElement(
	                "i",
	                { className: "fa fa-arrow-left" },
	                " Back to Home"
	              )
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "pview_section" },
	            _react2.default.createElement(
	              "div",
	              { className: "" },
	              _react2.default.createElement(_Heading2.default, { title: "In The Press" })
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "pview_intro_section" },
	              "For media inquiries, please write to",
	              " ",
	              _react2.default.createElement(
	                "a",
	                { href: "mailto:info@winpeforum.com" },
	                "info@winpeforum.com"
	              ),
	              "."
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "pview_mid_section" },
	              _react2.default.createElement(
	                "div",
	                { className: "row" },
	                pressJSX
	              )
	            )
	          )
	        )
	      )
	    );
	  };
	
	  return press;
	}(_react2.default.Component);
	
	press.propTypes = {
	  location: _propTypes2.default.object
	};
	
	exports.default = press;

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-press-index-js-530a903045dc45703a16.js